import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import '../assets/css/App.css';
import Background from "../assets/images/background.jpg";
import { relative } from 'upath';
import Header2 from './public';

const { SubMenu } = Menu;
const {
  Content, Footer
} = Layout;



class Welcome extends React.Component{
    constructor(props){
        super(props);
        this.state={
        }
    }
    
    componentWillMount(){
   
    }

    render(){
        return(
            
            <div style={{width:"100%"}}>
            <Header2></Header2>
            <Content style={{ padding: '0 50px' }}>

                <div>
                <div style={{background: `url(${Background}) no-repeat center center`,height:300,width: "100%",backgroundSize: "cover",}}>
                <div style={{textAlign:"center"}}>
                <br></br><br></br>
                  <txt style={{fontSize:50,fontWeight:'bold'}}>THE CIITOOL PLATFORM</txt> <br></br><br></br>
                  <txt style={{fontSize:42,fontWeight:'bold',}}>Improving the clinical cure of cancer through medical imaging analysis</txt>
                  </div>
                </div>



                <div style={{width:"100%"}}>

                    {/* 两个Module为一行*/}
                    
                    <div style={{float:"left", paddingTop:60,paddingLeft:100,paddingRight:100,paddingBottom:60,width: "50%",position:relative}}>

                        <txt style={{fontSize:30,fontWeight:'bold',textAlign:"center"}}><Link to="/mifa">Medical Image Feature Atlas</Link></txt><br></br>
                        <txt style={{fontSize:20,fontWeight:'bold',textAlign:"left"}}>Description: </txt>
                        <txt style={{fontSize:20,textAlign:"left"}}>
                        The traditional, predefined feature systems do not generally meet the stringent requirements for clinical utility, while deep learning approaches require further work before they can be translated into clinical use. The aim of this systematic review was to summarize previously reported, important medical imaging features of human cancers, and to clarify utilization of medical imaging features in clinical tasks pertaining to human cancer. We systematized the current knowledge of medical imaging features, and explored how these features could impact clinical practice, with a general focus on applications in oncology. Our study showed that blind feature dimensionality reduction is no longer the only way to obtain potential imaging biomarkers, and provided a basis for feature selection in all oncology tasks in a wide spectrum of human cancers.
                        </txt><br></br>
                        <img src={require('../assets/images/MIFA.jpg')} style={{ width: "100%",float:"center",backgroundSize: "cover"}}/>
                    </div>
                    <div style={{float:"left", paddingTop:60,paddingLeft:20,paddingRight:100,paddingBottom:60,width: "50%",position:relative}}>
                        <txt style={{fontSize:30,fontWeight:'bold',textAlign:"center"}}><Link to="/hcc">Hepatocellular Carcinoma</Link></txt><br></br>
                        <txt style={{fontSize:20,fontWeight:'bold',textAlign:"left"}}>Description: </txt>
                        <txt style={{fontSize:20,textAlign:"left"}}>
                        Evaluation of lipiodol deposition (LD) one month after TACE is one of the most improtant indicatord for efficacy assessment, which provides a reference for subsequent treatment. This parameter is the primary reference for embolization of target tumor regions, and previous studies have confirmed that, quantitative evaluation of LD provided a valid foundation for subsequent treatment decisions and follow-up plans. However, current classification methods of LD, such as deposition morphology, deposition ratio, deposition pattern, and necrosis, are non-uniform, and each method only considers a portion of the important aspects. Comprehensive analysis of LD one month after TACE is imperative for appropriate clinical treatment decision making. Our study thus proposed a standard method for measuring LD one month after TACE in patients with HCC, which could be a new predictor for clinical efficacy. 
                        </txt><br></br>
                        <img src={require('../assets/images/HCC1.jpg')} style={{ width: "100%",float:"center",backgroundSize: "cover"}}/>
                    </div><div style={{clear:"both"}}></div>
{/* 两个Module为一行
                     <div style={{float:"left", paddingTop:60,paddingLeft:100,paddingRight:100,paddingBottom:60,width:document.body.scrollWidth/2.2}}>

                        <txt style={{fontSize:30,fontWeight:'bold',textAlign:"center"}}>1</txt><br></br>
                        <txt style={{fontSize:20,fontWeight:'bold',textAlign:"left"}}>Description: </txt>
                        <txt style={{fontSize:20,textAlign:"left"}}>
                        E1</txt>
                        <br></br>
                        <img src={require('../assets/images/jds.jpg')} style={{ height:390,float:"left",backgroundSize: "cover"}}/>
                    </div>
                    <div style={{float:"left", paddingTop:60,paddingLeft:100,paddingRight:100,paddingBottom:60,width:document.body.scrollWidth/2.2}}>
                        <txt style={{fontSize:30,fontWeight:'bold',textAlign:"center"}}>1</txt><br></br>
                        <txt style={{fontSize:20,fontWeight:'bold',textAlign:"left"}}>Description: </txt>
                        <txt style={{fontSize:20,textAlign:"left"}}>
                        E1</txt>
                        <br></br>
                        <img src={require('../assets/images/jds.jpg')} style={{ height:390,float:"left",backgroundSize: "cover"}}/>
                    </div><div style={{clear:"both"}}></div> 
*/}             
                </div>
                
            </div>
            </Content>
            <Footer style={{fontSize:15}}><txt style={{fontWeight:'bold'}}>Disclaimer: </txt>This platform is for non-commercial use, and the analysis results provided are for auxiliary clinical use only. All actual clinical decisions and potential risks are the responsibility of clinicians or patients themselves. All use of the analysis results of this platform for commercial purposes without the permission of the owner of the platform will be subject to legal liability.
            <Footer style={{textAlign:"center"}}>
            <a href="http://www.beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style={{textAlign:"center"}}>Liao ICP No. 19003707-3</a>
            </Footer>
            </Footer>
            </div>
        )
    }
}
export default Welcome;